import TitleSection from './TitleSection';

export default TitleSection;
